import * as S from "effect-app/Schema"
import { MAX_AI_CHAT_MESSAGE } from "../AiChat.ts"
import { ComparisonOperator, ConditionActionType, RuleValidationMode } from "./Condition.ts"

// What the model sees and returns. Every reference is a catalog key ("o3",
// "o3.i2", "g1", "t1") or RECAP_KEY; ids never reach the model.
export const RECAP_KEY = "recap"
export const MAX_ASSIST_OPS = 20
const MAX_KEYED_VALUE = 2000

export const KeyedRule = S.Union([
  S.Struct({
    target: S.Literal("option"),
    option: S.String,
    operator: ComparisonOperator,
    value: S.String.pipe(S.check(S.isMaxLength(MAX_KEYED_VALUE)))
  }),
  S.Struct({
    target: S.Literal("group"),
    operator: S.Literals(["==", "!=", "in", "not_in"]),
    groups: S.Array(S.String).pipe(S.check(S.isBetweenLength(1, 50)))
  })
])
export type KeyedRule = typeof KeyedRule.Type

export const KeyedAction = S.Struct({
  type: ConditionActionType,
  option: S.String,
  value: S.NullOr(S.String.pipe(S.check(S.isMaxLength(MAX_KEYED_VALUE)))),
  images: S.optional(S.Array(S.Struct({ item: S.String, url: S.String })))
})
export type KeyedAction = typeof KeyedAction.Type

export const BlockDraft = S.Struct({
  mode: RuleValidationMode,
  rules: S.Array(KeyedRule),
  actions: S.Array(KeyedAction)
})
export type BlockDraft = typeof BlockDraft.Type

const BlockIndex = S.Int.pipe(S.check(S.isGreaterThanOrEqualTo(1)))

export const KeyedOp = S.Union([
  S.Struct({ op: S.Literal("append"), block: BlockDraft }),
  S.Struct({ op: S.Literal("replace"), index: BlockIndex, block: BlockDraft }),
  S.Struct({ op: S.Literal("remove"), index: BlockIndex })
])
export type KeyedOp = typeof KeyedOp.Type

export const ConditionAssistReply = S.String.pipe(
  S.check(S.isBetweenLength(1, MAX_AI_CHAT_MESSAGE))
)

// What the model is decoded into: the reply is unbounded here and clipped by
// clipAssistReply, so an over-long reply never discards a valid patch.
export const ConditionAssistModelOutput = S.Struct({
  reply: S.String,
  ops: S.Array(KeyedOp).pipe(
    S.check(S.isBetweenLength(0, MAX_ASSIST_OPS))
  )
})
export type ConditionAssistModelOutput = typeof ConditionAssistModelOutput.Type
